// extracted by mini-css-extract-plugin
module.exports = {"deckSearchDropdown":"deckTypeahead_deckSearchDropdown__mfrkK","categoryDropdown":"deckTypeahead_categoryDropdown__TG14g","header":"deckTypeahead_header__MIsVi"};